// Angular Files
import {
 Injectable, signal, WritableSignal
} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TellerOnlineRailNavigationService {
    // Public Variables
    public readonly elements: WritableSignal<TellerOnlineRailNavigationElement[]> = signal([]);

    public readonly enabled: WritableSignal<boolean> = signal(false);

    public addNavigation(elements: TellerOnlineRailNavigationElement[]) {
        this.elements.set(elements);
        this.enabled.set(true);
    }

    public removeNavigation() {
        this.enabled.set(false);
        this.elements.set([]);
    }
}

export class TellerOnlineRailNavigationElement {
    icon?: string;

    link: string;

    disabled?: boolean = false;

    text: string;

    singleLine?: boolean;

    /**
     * Marks the entry active only on its own url. Needed by an entry whose link is a prefix of
     * a sibling's — otherwise the sibling's pages light both of them up.
     */
    exactMatch?: boolean;

    /**
     * Other paths the entry's section owns: it stays active on them and on every page below
     * them, as a rail destination does on its sub-pages.
     */
    alsoActiveOn?: string[];
}
